import * as React from 'react';

import { IMoneySourceTabProps } from '../../types';
import { MoneySourceTab } from '../MoneySourceTab';
import * as styles from './MoneySourceTabs.css';

interface IProps {
  sources: IMoneySourceTabProps[];
}

export const MoneySourceTabs = ({ sources }: IProps) => (
  <div className={styles['wrapper']}>
    {sources.map((s, i) => (
      <MoneySourceTab key={i} {...s} />
    ))}
  </div>
);
